
<div class="AllconT">


  
  <div class="top_config">
    <h4>
      Order-<input type="number" id="Orderno" (keypress)="onkeypress($event)" [disabled]="isEnabled" [(ngModel)]="currentOrder" />
    </h4>
    <!--My Id is {{adConfid}}
    My Temp Id is {{adConftempid}}-->
    <button mat-mini-fab color="warn" (click)="deleteConf()" class="buttton_closee" *ngIf="isnew">
      <mat-icon>clear</mat-icon>
      <!--<mat-icon>not_interested</mat-icon>-->
    </button>

    <button mat-mini-fab color="warn" (click)="deleteConfDb(adConfid)" class="buttton_closee" *ngIf="!isnew && client">

      <mat-icon>delete</mat-icon>

    </button>
  </div>


    <div class="main_holder" cdkDropListGroup>
      <div class="main_text_btn_container">
        <div class="container-buttons">
          <div cdkDropList cdkDropListOrientation="horizontal" #buttonsList="cdkDropList" id="buttonsLists" [cdkDropListConnectedTo]="[droppesList]" [cdkDropListData]="elements"
               (cdkDropListDropped)="drop($event)">
            <div *ngFor="let button of elements">
              <ng-template [ngIf]="button.type == 'button'">
                <button mat-raised-button color="primary" (click)="transBtnElem(this.button)"
                        class="buttonRendered" cdkDrag>
                  {{button.name}}
                </button>
              </ng-template>
              <ng-template [ngIf]="button.type == 'text'">
                <mat-form-field class="example-full-width" appearance="fill" cdkDrag
                                (cdkDropListDropped)="drop($event)">
                  <input matInput value="{{button.name}}" (click)="transBtnElem(this.button)"
                         class="inp_drag">
                </mat-form-field>
              </ng-template>
            </div>
          </div>
        </div>


        <div class="container-buttons">

          <div cdkDropList cdkDropListOrientation="horizontal" #textsList="cdkDropList" id="textLists" [cdkDropListConnectedTo]="[droppesList]" [cdkDropListData]="phrases" (cdkDropListDropped)="drop($event)">
            <div *ngFor="let text of phrases">
              <ng-template [ngIf]="text.type == 'button'">
                <button mat-raised-button color="warn" (click)="transTxtElem(this.text)" class="buttonRendered"
                        cdkDrag>
                  {{text.name}}
                </button>
              </ng-template>
              <ng-template [ngIf]="text.type == 'text'">

                <mat-form-field class="example-full-width" appearance="fill" cdkDrag
                                (cdkDropListDropped)="drop($event)">
                  <input matInput value="{{text.name}}" (click)="transTxtElem(this.text)" class="inp_drag">
                </mat-form-field>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="placed_container">
        <div class="container-buttons" style="width: 100%;">


          <div cdkDropList cdkDropListOrientation="horizontal" id="result_drop"
               #droppesList="cdkDropList" [cdkDropListConnectedTo]="[buttonsList,textsList]" [cdkDropListData]="droppes" (cdkDropListDropped)="drop($event)">
            <div *ngFor="let droppe of droppes">
              <ng-template [ngIf]="droppe.type == 'button'">
                <button mat-raised-button color="accent" class="buttonRendered" cdkDrag>{{droppe.name}}</button>
              </ng-template>
              <ng-template [ngIf]="droppe.type == 'text'">
                <mat-form-field class="example-full-width" appearance="fill" cdkDrag
                                (cdkDropListDropped)="drop($event)">
                  <input matInput [(ngModel)]="droppe.inListValue" (keyup)="admakerAndSeedMAker()" class="inp_drag">
                </mat-form-field>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <mat-card>
        <mat-card-content><h5>Current SeedText :- {{this.myAd}}</h5></mat-card-content>
        <mat-card-content *ngIf="seedAd!=myAd"><h5>New SeedText :- {{this.seedAd}}</h5></mat-card-content>
      </mat-card>

    </div>
    <div class="dbSetting_wrapper" [hidden]="DataShow()">
      <mat-card style="display:none">
        <mat-card-content>
          <h4 class="example-h2">Result:-{{this.progress+'%'}}</h4>

          <section class="example-section">
            <mat-progress-bar mode="determinate" [value]="this.progress"></mat-progress-bar>
          </section>
        </mat-card-content>
      </mat-card><br>


      <div id="searchresultsarea" style="" [className]="blinking ? 'blink_me' : 'inactive'">
        <div class="searchresult">
          <h3 class="dbSetting_head">
            <span>
              <span style="float: right; font:10px" [ngStyle]="{color: getColor()}">
                {{this.result_str.length}}/{{this.limit}}
              </span>

            </span>
          </h3>
          <h2>{{showAdhere('Headline')|| 'Admaker Config Creator' }}</h2>
          <a>{{showAdhere('Path') || 'https://www.adfeeder.com' + (showAdhere('Deeplink') ||'?AdmakerAdded=NeCar') }} </a> <button>▼</button> 
                                                                                               <!--<a>{{showAdhere('Path') ||' https://www.adfeeder.com' }}</a>--> <!--<button>▼</button>-->
                                        <p *ngIf="showAdhere('Description') else nooa">
                                          {{showAdhere('Description') }} 
                                        </p>
                                        <ng-template #nooa>
                                          <p>
                                            Powering over 750 car dealer locations and pushing over 1.2 million ads into Google, Bing, Facebook and
                                            Instagram each day, AdFeeder is an
                                          </p>
                                          <p> environment where there are many threads of execution.</p>
                                        </ng-template>
        </div>
      </div>


      <br>


      <ng-container *ngIf="isnew  || seedAd!=myAd || currentOrder!=savedOrder">
        <button class="btn btn-success" ng-model="myvar" (click)="saveStr()">Save</button>&nbsp;
        <button class="btn btn-success" (click)="seedToDropes()">Reset</button>

      </ng-container>




    </div>

</div>
